import * as yup from 'yup';
import TranslationService from 'app/common/services/translation';
import { passcodeValidator } from 'app/pages/manage-documents/components/sharing/constants';
import passcodeValidateIllustration from './assets/images/passcode-illustration.svg';
import emailValidateIllustration from './assets/images/email-illustration.svg';

const contentChallengeEmail = {
  heading: TranslationService.get('FirstTellUsWhoYouAre'),
  body1: TranslationService.get(
    'ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress',
  ),
  body2: TranslationService.get(
    'WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument',
  ),
  inputBtnLabel: TranslationService.get('EnterAnEmailAddress'),
  submitBtnLabel: TranslationService.get('VerifyMyEmail_SentenceCase'),
};

const contentChallengePasscode = {
  heading: TranslationService.get('FirstEnterThePasscode'),
  body1: TranslationService.get(
    'ToAccessTheSharedDocumentYouNeedToEnterThePasscode',
  ),
  body2: TranslationService.get(
    'ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode',
  ),
  inputBtnLabel: TranslationService.get('EnterTheAccessPasscode'),
  submitBtnLabel: TranslationService.get('ViewDocument_SentenceCase'),
};

const contentSharingLinkValidationError = {
  heading: TranslationService.get('TheDocumentIsNoLongerAvailable'),
  body1: TranslationService.get(
    'YourAccessMayHaveBeenRemovedOrTheDocumentDeleted',
  ),
  body2: TranslationService.get(
    'ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore',
  ),
};

const contentEmailValidationSuccess = {
  heading: TranslationService.get('CheckYourInbox'),
  body1: TranslationService.get('WeHaveSentAnEmailToYourEmail'),
  body2: TranslationService.get('WithTheAccessToViewTheDocument'),
};

const contentDeviceStickinessError = {
  heading: TranslationService.get('YouAreOnADifferentDevice'),
  body1: TranslationService.get(
    'YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail',
  ),
};

const emailValidationSchema = yup.object().shape({
  challengeInput: yup
    .string()
    .trim()
    .email(TranslationService.get('EnterAValidEmailAddress'))
    .required(TranslationService.get('EmailIsRequired')),
});

const passcodeValidationSchema = yup.object().shape({
  challengeInput: passcodeValidator,
});

export {
  emailValidationSchema,
  passcodeValidationSchema,
  contentChallengeEmail,
  contentChallengePasscode,
  contentSharingLinkValidationError,
  contentEmailValidationSuccess,
  contentDeviceStickinessError,
  passcodeValidateIllustration,
  emailValidateIllustration,
};
